module.exports = __webpack_public_path__ + "static/media/review.948cf9ec.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/review.PNG
// module id = 1429
// module chunks = 0